import React from "react";
import { formatDate } from "utils/helperFunctions";

const BoolBadge = ({ value, trueLabel = "Yes", falseLabel = "No" }) => (
  <span
    className={`px-2 py-1 rounded-full text-xs font-medium ${
      value ? "bg-green-100 text-green-800" : "bg-lightgray text-darkgray"
    }`}
  >
    {value ? trueLabel : falseLabel}
  </span>
);

export default function AgencyPartyView({ agencyParty }) {
  if (!agencyParty) return null;

  const hasSignatory = agencyParty.signatoryName || agencyParty.signature;

  return (
    <div className="bg-white">
      {/* Header */}
      <div className="bg-lightgray p-6 rounded-lg mb-6">
        <div className="flex justify-between items-start">
          <div>
            <div className="text-base font-semibold text-black mb-2 flex items-center gap-2">
              {agencyParty.company}
              <span
                className={`text-xs px-2 py-1 rounded-full font-medium ${
                  agencyParty.gst === "Yes"
                    ? "bg-green-100 text-green-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {agencyParty.gst === "Yes" ? "GST Registered" : "No GST"}
              </span>
            </div>
            {agencyParty.licenceNumber ? (
              <p className="text-darkgray font-mono text-sm">
                Licence: {agencyParty.licenceNumber}
              </p>
            ) : (
              <p className="text-darkgray text-sm">No licence number</p>
            )}
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {/* Business Information */}
        <div>
          <div className="font-medium text-black mb-3">
            Business Information
          </div>
          <div className="bg-lightgray rounded-lg p-4 space-y-3">
            <div className="flex justify-between">
              <span className="text-darkgray">Company:</span>
              <span className="text-black font-medium">
                {agencyParty.company}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-darkgray">ABN:</span>
              <span className="text-black font-mono">
                {agencyParty.abn || "Not set"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-darkgray">GST Registered:</span>
              <BoolBadge value={agencyParty.gst === "Yes"} />
            </div>
            <div className="flex justify-between">
              <span className="text-darkgray">Licence Number:</span>
              <span className="text-black font-mono">
                {agencyParty.licenceNumber || "Not set"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-darkgray">Created:</span>
              <span className="text-black">
                {formatDate(agencyParty.createdAt)}
              </span>
            </div>
          </div>
        </div>

        {/* Contact Details */}
        <div>
          <div className="font-medium text-black mb-3">Contact Details</div>
          <div className="bg-lightgray rounded-lg p-4 space-y-3">
            <div className="flex justify-between">
              <span className="text-darkgray">Address:</span>
              <span className="text-black text-right max-w-[60%]">
                {agencyParty.address || "Not set"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-darkgray">Phone:</span>
              <span className="text-black">
                {agencyParty.phone || "Not set"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-darkgray">Email:</span>
              <span className="text-black">
                {agencyParty.email || "Not set"}
              </span>
            </div>
          </div>
        </div>

        {/* Signatory Details — only shown when present */}
        {hasSignatory && (
          <div>
            <div className="font-medium text-black mb-3">Signatory Details</div>
            <div className="bg-lightgray rounded-lg p-4 space-y-3">
              <div className="flex justify-between">
                <span className="text-darkgray">Signatory Name:</span>
                <span className="text-black font-medium">
                  {agencyParty.signatoryName || "Not set"}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-darkgray">Signature:</span>
                <span className="text-black text-right max-w-[60%] break-all">
                  {agencyParty.signature || "Not set"}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
